import LogRocket from 'logrocket'

LogRocket.init('0pof5j/guide')



// WEBPACK FOOTER //
// ./src/startup/logrocket.js